<template>
  <div id="join-form" class="modal-form">
    <div class="container">
      <perfect-scrollbar>
      <button class="btn close-button" @click="onClickClose()">Close</button>
      <div class="clearfix" />
      <form @submit.prevent="onSubmit()">
        <h2 class="form-title">Join Contest</h2>
        <div class="form-group row">
          <label for="companyName" class="form-label col-md-12 mb-0 pb-0"
            >Contest name</label
          >
          <div class="col-md-12 mt-0 pt-0">
            <select v-model="experienceId" class="form-control">
              <option value="">Pick experience to join</option>
              <option
                v-for="(item, index) in experience"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
          </div>
        </div>

        <h4>Prizes</h4>
        <p>
          This contest requires every experience that joins to contribute a
          prize.
        </p>
        <p>Minimum value: USD 100.00</p>

        <div class="form-group row">
          <label for="companyName" class="form-label col-md-3">Title*</label>
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              id="title"
              v-model="formData.name"
              required
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="hashtag" class="form-label col-md-3">Sponsor</label>
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              id="hashtag"
              v-model="formData.sponsor"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="description" class="form-label col-md-3"
            >Description</label
          >
          <div class="col-md-9">
            <textarea
              id="description"
              v-model="formData.description"
              class="form-control"
              rows="4"
            ></textarea>
          </div>
        </div>

        <div class="form-group row">
          <label for="value" class="form-label col-md-3">Value (USD)</label>
          <div class="col-md-9">
            <input
              type="number"
              min="100"
              step="50"
              class="form-control"
              id="value"
              v-model="formData.value"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="description" class="form-label col-md-3">Image</label>
          <div class="col-md-9">
            <ImageUploadButton
              ref="imageUploader"
              :imageUrl="formData && formData.images ? formData.images : ''"
              @clear="onClearUploadImage"
            />
          </div>
        </div>

        <div class="row">
          <h3>Declaration*</h3>
        </div>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" />
          <label class="form-check-label text-body" for="exampleCheck1"
            >I confirm that I am participating in this contest. I understand
            that once confirmed, I will NOT be able to withdraw my
            participation.
          </label>
        </div>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="exampleCheck2" />
          <label class="form-check-label text-body" for="exampleCheck2"
            >I confirm that I am the rightful owner and have permission to
            provide the prize to the contest.
          </label>
        </div>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="exampleCheck3" />
          <label class="form-check-label text-body" for="exampleCheck3"
            >I confirm that I have read an agree to the Terms & Conditions of
            the contest</label
          >
        </div>

        <div class="form-actions">
          <input type="submit" value="SEND" class="btn btn-primary" />
          <button type="button" class="btn" @click="onClickClose()">
            CLOSE
          </button>
        </div>
      </form>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { getUserId } from "@/services/UserService";
import ImageUploadButton from "@/components/ImageUploadButton";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

export default {
  components: { ImageUploadButton, PerfectScrollbar },
  props: {
    campaignId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      experienceId: "",
      formData: {
        name: "",
        description: "",
        sponsor: "",
        value: 0,
        valueCurrency: "USD",
        images: undefined,
      },
      experience: [],
    };
  },
  mounted() {
    this.onLoadExperience();
  },
  methods: {
    async onLoadExperience() {
      this.experience = await this.$repo.contest.userContents2();
    },
    onClickClose() {
      this.$emit("close");
    },
    async onSubmit() {
      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.images = [files[0].url];
      }

      if (this.formData.value) {
        this.formData.value = parseFloat(this.formData.value);
      }

      const campaignId = this.campaignId;
      const experienceId = this.experienceId;
      const message = "";
      this.$repo.contest
        .requestCampaignExperienceApproval(
          campaignId,
          experienceId,
          message,
          this.formData
        )
        .then((result) => {
          this.$emit("success");
        });
    },
    onClearUploadImage() {
      this.formData.images = "";
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    upload(files) {
      return new Promise((resolve, reject) => {
        if (files) {
          const userId = getUserId();
          this.$repo.file
            .upload(files, userId, userId)
            .then(resolve)
            .catch(reject);
        } else {
          resolve();
        }
      });
    },
    onUploadFilesChange(files) {
      console.log(files);
      this.formData.imageFile =
        files && files.length > 0 ? files[0] : undefined;
    },
  },
};
</script>

<style lang="scss">
$main-color: #1da1f2;

#join-form {

  .close-button {
    margin-bottom: 20px;
    float: right;
  }
  .ps {
        height: 85vh;
      }

  .container {
    max-width: 670px;
  }

  .form-title {
    color: $main-color;
  }

  .form-label {
    color: #000;
  }

  h2,
  h3 {
    margin: 0 0 0.5em;
  }

  form {
    background-color: #fff;
    padding: 30px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
    color: #000;
  }

  .form-actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }

  .btn {
    min-width: 150px;
  }

  .btn-primary {
    background-color: $main-color;
  }

  .ew-file-uploader .label {
    display: none;
  }

  .form-check-label {
    line-height: 22px;
  }
}
</style>
